import React, { useState } from "react";
import axios from "axios";
import config from '../../config/config'
import {connect} from 'react-redux';

const MultiImageUpload = ({ updateImages, postAdData }) => {
  const [images, setImages] = useState([]);

  const handleFileChange = (event) => {
    const files = event.target.files;
    const newImages = Array.from(files).map((file) => ({
      id: URL.createObjectURL(file), // Unique ID for rendering
      url: URL.createObjectURL(file), // Preview URL
    }));

    setImages((prevImages) => [...prevImages, ...newImages]);
    // const imageArray = Array.from(files).map((file) => URL.createObjectURL(file)); // Generate preview URLs
    // setImages(imageArray);
    // setImages([...event.target.files]); // Store selected files
    handleUpload([...event.target.files]);
  };

  const handleUpload = async (imageArray) => { 
    const formData = new FormData();
    imageArray.forEach((image) => {
      formData.append("images[]", image); // Append each file
      
      // console.log('image', image)
    });
    
    try {
      const response = await axios.post(config.blogApiUrl+'property/upload-property-images.json', formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      updateImages(response.data.data.files)
      // console.log("Upload successful:", response.data.data.files);
    } catch (error) {
      console.error("Upload error:", error);
    }
  };

  return (
    <div>
      <div style={{ display: "flex", gap: "10px", marginTop: "10px", flexWrap: "wrap" }} className="mb-3">
        { postAdData && postAdData.propertyImages && postAdData.propertyImages.length > 0 ?
            postAdData.propertyImages.map((image, imageIndex) => (
              <img key={`propertyIage-formData-${imageIndex}`} src={`${config.uploadUrl}${image}`} alt="Preview" style={{ width: "150px", height: "150px", objectFit: "cover", borderRadius:'8px', borderWidth:'1px', borderColor:'#dddddd', borderStyle:'solid' }} />
            ))
          :''
        }
        {images.map((image) => (
          <img key={`propertyIage${image.id}`} src={image.url} alt="Preview" style={{ width: "150px", height: "150px", objectFit: "cover", borderRadius:'8px', borderWidth:'1px', borderColor:'#dddddd', borderStyle:'solid' }} />
        ))}
      </div>
      <input type="file" multiple onChange={handleFileChange} />
    </div>
  );
};

function mapStateToProps(state) {
  return {
    postAdData: state.postData && state.postData.postAdData ? state.postData.postAdData : ''
  };
}

function mapDispatchToProps(dispatch) {
  return {
      
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(MultiImageUpload);

